// extracted by mini-css-extract-plugin
module.exports = {"recordBox":"StoreList_recordBox__C1kUv"};